import { AccountAPIList } from '@/api'

const api = new AccountAPIList();

export default {
  getUserDetail({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getUserDetail(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    });
  },
  getUserTxn({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getUserCreditsTxn(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    });
  },
  editUserPassword({ state }, param) {
    return new Promise((resolve, reject) => {
      api.editUserPassword(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    });
  },
  editReceipt({ state }, param) {
    return new Promise((resolve, reject) => {
      api.editReceipt(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/Account/store/actions.js